var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { FloatingFocusManager } from '@floating-ui/react';
import { ARROW_UP_KEY, ENTER_KEY, TAB_KEY } from '#constants';
import { Box } from '../Box';
import { ContextMenuTestIdFactory } from './interactions';
import { useContextMenu } from './useContextMenu';
import styles from './ContextMenu.module.css';
export const ContextMenu = ({ children, 'data-testid': testId, id: menuId, trackContextMenuOpenState, triggerElement, }) => {
    _react_refresh_temp_2();
    const { context, isContextMenuOpen, setIsContextMenuOpen, targetProps } = useContextMenu({
        triggerElement,
        menuId,
        trackContextMenuOpenState,
    });
    const eventHandler = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setIsContextMenuOpen(false);
    };
    // An item may open a modal, which on close refocuses what held focus on open.
    const focusTrigger = () => {
        triggerElement.current?.focus({ preventScroll: true });
    };
    const onKeyDownCaptureHandler = (event) => {
        if (event.key === ENTER_KEY) {
            focusTrigger();
        }
    };
    const onKeyDownHandler = (event) => {
        if (event.key === ENTER_KEY ||
            event.key === TAB_KEY ||
            (event.key === ARROW_UP_KEY && event.altKey)) {
            event.preventDefault();
            event.stopPropagation();
            setIsContextMenuOpen(false);
        }
    };
    return isContextMenuOpen ? (_jsx(FloatingFocusManager, { context: context, guards: false, modal: false, children: _jsx("div", { className: styles.Container, "data-testid": ContextMenuTestIdFactory.getContextMenuTestId(testId), id: menuId, ...targetProps, onClick: eventHandler, onClickCapture: focusTrigger, onKeyDown: onKeyDownHandler, onKeyDownCapture: onKeyDownCaptureHandler, children: _jsx(Box, { gap: "s", kind: "level3", orientation: "vertical", padding: "s", radius: "m", shadow: "shallow", children: children }) }) })) : null;
};
_react_refresh_temp_1 = ContextMenu;
$RefreshReg$(_react_refresh_temp_1, "ContextMenu");
_react_refresh_temp_2(ContextMenu, "u/fV32j8z8tvKeWzi1XBPQZsalU=", false, () => [useContextMenu]);
